<template>
<div>
<ContentHeader  v-if="item"  :title="$store.state.languages.lang_phrases.soru+' '+$store.state.languages.lang_phrases.genel+' '+$store.state.languages.lang_phrases.durum"  :show_button="true"  icon="arrow-left" buttontype="danger" label="Listeye Geri Dön" url="QuestionlistQuestions" :urlparams="headerurlparams"></ContentHeader>
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<div class="mt-4">


<ClickEditInputText  title="Soru" :value="item.name" valkey="name" @dataChanged="dataChanged" />
<ClickEditInputTextArea  title="Açıklama" :value="item.description" valkey="description" @dataChanged="dataChanged" />

<ClickEditSelect title="Tür" :value="item.type" :options="types" valkey="type" @dataChanged="dataChanged"  />

<ClickEditNumber title="Soru Puanı" :value="item.points" valkey="points" @dataChanged="dataChanged"  :steps="0.01" v-if="$store.state.questions.question.questionlist.calculate_points" />
<template v-if="item.type=='select' || item.type=='multiselect' || item.type=='columns'|| item.type=='listselect'">
<ClickEditSwitch  title="Her Sütun Doldurma Tam Puan" :value="item.any_submission_full_points" valkey="any_submission_full_points" @dataChanged="dataChanged"  v-if="$store.state.questions.question.questionlist.calculate_points" />
</template>

<ClickEditSwitch  title="Aktif" :value="item.active" valkey="active" @dataChanged="dataChanged" />
<ClickEditSwitch  title="Görünür" :value="item.show_field" valkey="show_field" @dataChanged="dataChanged" />
<ClickEditSwitch  title="Gerekli" :value="item.is_required" valkey="is_required" @dataChanged="dataChanged" />
<ClickEditSwitch   v-if="item.is_required" title="Boş Geçilebilir" :value="item.is_nullable" valkey="is_nullable" @dataChanged="dataChanged" />

<ClickEditSwitch   v-if="item.type=='select' ||item.type=='multiselect'" title="Seçenekleri Yatay Göster" :value="item.horizontal_select" valkey="horizontal_select" @dataChanged="dataChanged" />



<ClickEditSwitch  v-if="item.is_required && item.is_nullable" title="Boş Bırakma Nedeni Gerekli" :value="item.is_null_reason_required" valkey="is_null_reason_required" @dataChanged="dataChanged" />


<ClickEditNumber v-if="item.type=='text'|| item.type=='longtext'" title="Min Karakter Sayısı" :value="item.min_char_length" valkey="min_char_length" @dataChanged="dataChanged"  :steps="1" />

<ClickEditNumber v-if="item.type=='text'|| item.type=='longtext'" title="Max Karakter Sayısı" :value="item.max_char_length" valkey="max_char_length" @dataChanged="dataChanged"  :steps="1" />

<ClickEditNumber v-if="item.type=='listinput'" title="Min Giriş Sayısı" :value="item.min_item_lenght" valkey="min_item_lenght" @dataChanged="dataChanged"  :steps="1" />

<ClickEditNumber v-if="item.type=='listinput'" title="Max Giriş Sayısı" :value="item.max_item_lenght" valkey="max_item_lenght" @dataChanged="dataChanged"  :steps="1" />


<!--<ClickEditSelect v-if="item.type=='listinput'" title="Giriş Doğrulama Türü" :value="item.listinput_type" :options="listinputtypes" valkey="listinput_type" @dataChanged="dataChanged"  />-->

<ClickEditSelect v-if="item.type=='text'" title="Giriş Doğrulama Türü" :value="item.validation_type" :options="validation_types" valkey="validation_type" @dataChanged="dataChanged"  />


<ClickEditNumber v-if="item.type=='number'" title="Min Değer" :value="item.min_value" valkey="min_value" @dataChanged="dataChanged"  :steps=".1" />

<ClickEditNumber v-if="item.type=='number'" title="Max Değer" :value="item.max_value" valkey="max_value" @dataChanged="dataChanged"  :steps=".1" />

<ClickEditNumber v-if="item.type=='number'" title="Max Küsürat" :value="item.allowed_fraction" valkey="allowed_fraction" @dataChanged="dataChanged"  :steps=".1" />

<ClickEditSwitch  title="Kanıt İste" :value="item.ask_for_evidence" valkey="ask_for_evidence" @dataChanged="dataChanged" />
<ClickEditSwitch   v-if="item.ask_for_evidence" title="Kanıt Gerekli" :value="item.is_evindence_required" valkey="is_evindence_required" @dataChanged="dataChanged" />



<ClickEditNumber v-if="item.is_evindence_required" title="Min Kanıt Sayısı" :value="item.min_evidences" valkey="min_evidences" @dataChanged="dataChanged"  :steps="1" />
<ClickEditNumber v-if="item.is_evindence_required" title="Max Kanıt Sayısı" :value="item.max_evidences" valkey="max_evidences" @dataChanged="dataChanged"  :steps="1" />

<ClickEditSwitch  title="Kayıt Notu İste" :value="item.ask_for_submission_note" valkey="ask_for_submission_note" @dataChanged="dataChanged" />
<ClickEditSwitch  v-if="item.ask_for_submission_note" title="Kayıt Notu Gerekli" :value="item.submission_note_required" valkey="submission_note_required" @dataChanged="dataChanged" />

<ClickEditSelect v-if="item.ask_for_submission_note" title="Gösterim" :value="item.submission_note_show_type" :options="notedisplaytyped" valkey="submission_note_show_type" @dataChanged="dataChanged"  />

<ClickEditMultiSelect v-if="$store.state.questions.question.questionlist.inputfieldclasses.length" title="Sınıfı" :value="item.inputfieldclasses" :options="inputfield_classes" valkey="inputfieldclasses" @dataChanged="dataChanged"  />

<ClickEditSwitch  v-if="item.type=='location'" title="Posta Kodu Zorunlu" :value="item.is_postalcode_required" valkey="is_postalcode_required" @dataChanged="dataChanged" />




</div>
</template>

</div>
</template>

<script>
export default {

  name: 'QuestionGeneral',

  data () {
    return {
    	item:null,
    	loading:true,
      notedisplaytyped:[
        {name:"Kayıt Girildiğinde",id:"on_input"},
        {name:"Herzaman",id:"always"},
      ],
      inputfield_classes:[{name:"Sınıf yok",id:0}],
      listinputtypes:[
        {name:"Email",id:"email"},
        {name:"Text",id:"string"},
        {name:"Sayı",id:"number"},
        {name:"Link",id:"url"},
        {name:"Telefon No",id:"phoneno"},
      ],
      validation_types:[
        {name:"Email",id:"email"},
        {name:"Text",id:"string"},
        {name:"Sayı",id:"number"},
        {name:"Link",id:"url"},
        {name:"Tarih",id:"date"},
      ],
      types:[
        {name:"Text",id:"text"},
        {name:"Uzun Text",id:"longtext"},
        {name:"Lokasyon",id:"location"},
        {name:"Sayı",id:"number"},
        {name:"Seçim",id:"select"},
        {name:"Çoklu Seçim",id:"multiselect"},        
        {name:"Listeden Seçim",id:"listselect"},
        {name:"Sütunlar",id:"columns"},
        {name:"Doğru/Yanlış",id:"boolean"},
        {name:"Eklemeli Liste",id:"listinput"},
        {name:"Düz Metin",id:"readonlytext"},
        ],
    }
  },
  mounted()
  {
    this.$store.dispatch('ui/setActiveTab',"soru")
    this.getData()
  },
  computed:{
    headerurlparams()
    {
      return {id:this.item.questionlist_id}
    }
  },
  methods:{
  	async getData()
    {
        this.item = await this.generalApiGetWithoutLoader("questionlists/inputfield/"+this.$route.params.id)
        console.log(this.item)
        this.inputfield_classes = await this.item.questionlist.inputfieldclasses

        this.loading = await false
    },   
    questionClassChanged(data)
    {
      console.log(data)
    },
    dataChanged(data)
    {
      console.log(data.value)
      console.log(data.key)
      //return false
      let formdata = new FormData()
      formdata.append(data.key,data.value)      
      this.generalSubmission(formdata,"questionlists/inputfield/update/"+this.item.id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      console.log(response);      
      this.item = response.data
      this.$store.dispatch('questions/setQuestion',this.item)
    },
  },
};
</script>

<style lang="css" scoped>
</style>